/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import Grid from '@mui/material/Grid';

import ContentContainer from '../components/contentContainer';
import WidgetDialog from '../components/dialogs';
import TitleHeader from '../components/titleHeader';
import PrimaryButton from '../components/primaryButton';

import { useStyles } from './styles';

import useWidgetTheme from '../../commons/widgetTheme';
import TranslationIds from '../../commons/translationIds';
import useTranslator from '../../commons/translations';
import SubscribersFields from './fields';
import useUIStates from '../../store/models/uistates/useUIStates';
import { useSubscriberStore } from '../../store/models/subscriber';
import getCommonUIStyles from '../../commons/uiStyles';
import useCommonStores from '../../store/useCommonStores';
import usePageTransitions from '../../store/models/animations/usePageTransitions';
import transitions, 
{
    TransitionDirection,
    TransitionViewNames,
    TransitionViewRenderers,
} from '../../store/models/animations/actions/transitions';
import useKickstarted from '../../commons/hooks/useKickstarted';

function SubscriberRegistration (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;

    const  {
        translate,
        translateHTMLMessage,
    } = useTranslator();

    const subscriberStore = useSubscriberStore();
    useKickstarted({});

    const {
        appStore,
    } = useCommonStores();

    const {
        widget,
        widgetTheme,
        hasCustomCSS,
    }  = useWidgetTheme();

    const classes = useStyles({
        widget,
        widgetTheme,
        hasCustomCSS,
        commonUIStyles: getCommonUIStyles({ widgetTheme, widget }),
    });

    const {
        isRequiredFilledIn,
        hasErrors,
        initializeUIValues,
    } = useUIStates();

    const {
        setTransitionsWithTarget,
        setViewRenderer,
    } = usePageTransitions({
        elementName: TransitionViewNames.SUBSCRIBER_VIEW,
        viewAnimation,
    });

    useEffect(() => {
        initializeUIValues();
    }, []);

    function animateBack () {
        setViewRenderer(TransitionViewRenderers.CALENDARS_VIEW);
        setTransitionsWithTarget({
            direction: TransitionDirection.BACK,
            animationIn: transitions.slideInFromBack,
            animationOut: transitions.slideOutToNext,
            incomingView: TransitionViewNames.CALENDARS_VIEW,
            outgoingView: TransitionViewNames.SUBSCRIBER_VIEW,
        });
        appStore.gotoCalendarApps();
    }
    if (!appStore.kickstarted) {
        return (<React.Fragment></React.Fragment>);
    }
    return (
        <React.Fragment>
            <ContentContainer>
                <WidgetDialog
                    id={TransitionViewNames.SUBSCRIBER_VIEW}
                    name={TransitionViewNames.SUBSCRIBER_VIEW}
                    goToBackPage={() => {
                        animateBack();
                    }}

                    viewAnimation={viewAnimation}
                    isShowBackButton={true}
                    initStyles={initStyles}
                >
                    <Grid className={classes.headerSpace}>
                        <TitleHeader
                            widget={widget}
                            widgetTheme={widgetTheme}
                            title={translate(TranslationIds.REGISTRATION_CONFIRM_DETAILS)}
                        />
                    </Grid>

                    <Grid className={classes.content}>
                        <Grid id="registration-form-container" className={classNames(['registration-form-container', classes.listSpaceContainer])}>
                            <Grid id="registration-form" className={classNames(['registration-form', classes.listSpace])}>
                                <SubscribersFields />
                                    <p 
                                        id="ecal-privacy-text-optin"
                                        className={classNames(['Registration__privacyTextOptin___v1', 'ecal-reg-field-privacy-text-optin', classes.privacy])}
                                    >
                                        <span className={classes.privacyText}>{translateHTMLMessage(TranslationIds.COMPONENT_PRIVACY_TEXT)}</span>
                                    </p>
                            </Grid>
                        </Grid>
                        
                        <Grid className={classNames([classes.actionPanel, 'ecal-primary-button-container'])}>
                            <PrimaryButton
                                isDisabled={!isRequiredFilledIn || !hasErrors()}
                                onClick={() => {
                                    appStore.gaEnterDetails();
                                    subscriberStore.subscribeFromForm();
                                }}
                                textLabel={translate(TranslationIds.COMPONENT_NEXT)}
                            />
                         </Grid>

                    </Grid>

                </WidgetDialog>
            </ContentContainer>           
        </React.Fragment>
    );
}

SubscriberRegistration.propTypes = {
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};

export default observer(SubscriberRegistration);